import { Option } from "../generated"

// 日本語 -> 英語
// 研究生・修士・博士など現状の希望入学課程 -> regularStudent
// 特別聴講学生・特別研究学生 -> specialAuditingOrResearchStudent
// 短期国際交流学生 -> shortTermExchangeStudent
// 科目等履修生 -> nonDegreeCourseStudent
export type ProgramType = 'RegularStudent' | 'SpecialAuditingOrResearchStudent' | 'ShortTermExchangeStudent' | 'NonDegreeCourseStudent'

export function convertProgramType(programTypeOption: Option | undefined): ProgramType {
  if (programTypeOption === undefined || programTypeOption === null) {
    return DEFAULT_PROGRAM_TYPE
  }
  switch (programTypeOption.code) {
    case 'regularStudent':
      return 'RegularStudent'
    case 'specialAuditingOrResearchStudent':
      return 'SpecialAuditingOrResearchStudent'
    case 'shortTermExchangeStudent':
      return 'ShortTermExchangeStudent'
    case 'nonDegreeCourseStudent':
      return 'NonDegreeCourseStudent'
    default:
      throw new Error(`Unknown program type: ${programTypeOption.code}`)
  }
}
export const DEFAULT_PROGRAM_TYPE: ProgramType = 'RegularStudent'